// chakra imports
import {
  Box,
  Flex,
  IconButton,
  Stack,
  useColorModeValue,
} from "@chakra-ui/react";
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import SidebarCard from "components/sidebar/components/SidebarCard";
import { Mark } from "components/icons/Mark";
import { useSidebar } from "contexts/SidebarContext";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import type { ElementType } from "react";

function SidebarContent(props: { routes: RoutesType[] }) {
  const { routes } = props;
  const { sidebarCollapsed, setSidebarCollapsed } = useSidebar();
  const btnColor = useColorModeValue("gray.600", "whiteAlpha.800");

  return (
    <Flex direction="column" height="100%" pt="12px" borderRadius="30px">
      <Flex
        justify="flex-end"
        px={sidebarCollapsed ? "6px" : "12px"}
        pe="16px"
        display={{ base: "none", xl: "flex" }}
        align="center"
        minH="36px"
      >
        <IconButton
          aria-label={
            sidebarCollapsed ? "Expandir menu lateral" : "Recolher menu lateral"
          }
          icon={
            sidebarCollapsed ? (
              <Mark as={MdChevronRight as ElementType} w="22px" h="22px" />
            ) : (
              <Mark as={MdChevronLeft as ElementType} w="22px" h="22px" />
            )
          }
          variant="ghost"
          size="sm"
          color={btnColor}
          onClick={() => setSidebarCollapsed((c) => !c)}
        />
      </Flex>
      <Brand />
      <Stack direction="column" mt="8px" mb="auto">
        <Box
          ps={sidebarCollapsed ? "6px" : "20px"}
          pe={{ lg: sidebarCollapsed ? "6px" : "16px", "2xl": "16px" }}
        >
          <Links routes={routes} />
        </Box>
      </Stack>

      {!sidebarCollapsed ? (
        <Box
          ps="20px"
          pe={{ lg: "16px", "2xl": "20px" }}
          mt="60px"
          mb="40px"
          borderRadius="30px"
        >
          <SidebarCard />
        </Box>
      ) : null}
    </Flex>
  );
}

export default SidebarContent;
